__turbopack_context__.v({
  "active": "booking-form-module-scss-module__BeivHa__active",
  "addPointButton": "booking-form-module-scss-module__BeivHa__addPointButton",
  "additionalInputs": "booking-form-module-scss-module__BeivHa__additionalInputs",
  "bookYourFlight": "booking-form-module-scss-module__BeivHa__bookYourFlight",
  "bookingform": "booking-form-module-scss-module__BeivHa__bookingform",
  "buttonGroup": "booking-form-module-scss-module__BeivHa__buttonGroup",
  "errorMessage": "booking-form-module-scss-module__BeivHa__errorMessage",
  "firstline": "booking-form-module-scss-module__BeivHa__firstline",
  "flightSummaryAircraftPrice": "booking-form-module-scss-module__BeivHa__flightSummaryAircraftPrice",
  "flightSummaryCard": "booking-form-module-scss-module__BeivHa__flightSummaryCard",
  "flightSummaryCity": "booking-form-module-scss-module__BeivHa__flightSummaryCity",
  "flightSummaryDot": "booking-form-module-scss-module__BeivHa__flightSummaryDot",
  "flightSummaryFromTo": "booking-form-module-scss-module__BeivHa__flightSummaryFromTo",
  "flightSummaryHeader": "booking-form-module-scss-module__BeivHa__flightSummaryHeader",
  "flightSummaryImageCard": "booking-form-module-scss-module__BeivHa__flightSummaryImageCard",
  "flightSummaryImageInfo": "booking-form-module-scss-module__BeivHa__flightSummaryImageInfo",
  "flightSummaryImageMeta": "booking-form-module-scss-module__BeivHa__flightSummaryImageMeta",
  "flightSummaryImageName": "booking-form-module-scss-module__BeivHa__flightSummaryImageName",
  "flightSummaryImagePhoto": "booking-form-module-scss-module__BeivHa__flightSummaryImagePhoto",
  "flightSummaryImageTail": "booking-form-module-scss-module__BeivHa__flightSummaryImageTail",
  "flightSummaryImages": "booking-form-module-scss-module__BeivHa__flightSummaryImages",
  "flightSummaryJetCategory": "booking-form-module-scss-module__BeivHa__flightSummaryJetCategory",
  "flightSummaryLegDivider": "booking-form-module-scss-module__BeivHa__flightSummaryLegDivider",
  "flightSummaryLegs": "booking-form-module-scss-module__BeivHa__flightSummaryLegs",
  "flightSummaryLine": "booking-form-module-scss-module__BeivHa__flightSummaryLine",
  "flightSummaryMeta": "booking-form-module-scss-module__BeivHa__flightSummaryMeta",
  "flightSummaryMultiRoute": "booking-form-module-scss-module__BeivHa__flightSummaryMultiRoute",
  "flightSummaryMultiStop": "booking-form-module-scss-module__BeivHa__flightSummaryMultiStop",
  "flightSummaryPassengers": "booking-form-module-scss-module__BeivHa__flightSummaryPassengers",
  "flightSummaryPlaneIcon": "booking-form-module-scss-module__BeivHa__flightSummaryPlaneIcon",
  "flightSummaryPoint": "booking-form-module-scss-module__BeivHa__flightSummaryPoint",
  "flightSummaryPrice": "booking-form-module-scss-module__BeivHa__flightSummaryPrice",
  "flightSummaryPriceLabel": "booking-form-module-scss-module__BeivHa__flightSummaryPriceLabel",
  "flightSummaryPriceNote": "booking-form-module-scss-module__BeivHa__flightSummaryPriceNote",
  "flightSummaryPriceRow": "booking-form-module-scss-module__BeivHa__flightSummaryPriceRow",
  "flightSummaryReturnPolicy": "booking-form-module-scss-module__BeivHa__flightSummaryReturnPolicy",
  "flightSummaryRoute": "booking-form-module-scss-module__BeivHa__flightSummaryRoute",
  "flightSummaryTitle": "booking-form-module-scss-module__BeivHa__flightSummaryTitle",
  "formBlockMulti": "booking-form-module-scss-module__BeivHa__formBlockMulti",
  "formCurrentTab": "booking-form-module-scss-module__BeivHa__formCurrentTab",
  "formCurrentTabContainer": "booking-form-module-scss-module__BeivHa__formCurrentTabContainer",
  "formCurrentTabItem": "booking-form-module-scss-module__BeivHa__formCurrentTabItem",
  "formOuter": "booking-form-module-scss-module__BeivHa__formOuter",
  "formblock": "booking-form-module-scss-module__BeivHa__formblock",
  "inputWrapper": "booking-form-module-scss-module__BeivHa__inputWrapper",
  "item": "booking-form-module-scss-module__BeivHa__item",
  "item1": "booking-form-module-scss-module__BeivHa__item1",
  "item2": "booking-form-module-scss-module__BeivHa__item2",
  "line": "booking-form-module-scss-module__BeivHa__line",
  "line2": "booking-form-module-scss-module__BeivHa__line2",
  "multiCityBottomRow": "booking-form-module-scss-module__BeivHa__multiCityBottomRow",
  "multiCityForm": "booking-form-module-scss-module__BeivHa__multiCityForm",
  "multiCityFormContainer": "booking-form-module-scss-module__BeivHa__multiCityFormContainer",
  "multiCityLegInputs": "booking-form-module-scss-module__BeivHa__multiCityLegInputs",
  "multiCityLegLabel": "booking-form-module-scss-module__BeivHa__multiCityLegLabel",
  "multiCityLegRow": "booking-form-module-scss-module__BeivHa__multiCityLegRow",
  "multiCityLegsSection": "booking-form-module-scss-module__BeivHa__multiCityLegsSection",
  "nextButton": "booking-form-module-scss-module__BeivHa__nextButton",
  "tabactive": "booking-form-module-scss-module__BeivHa__tabactive",
  "tabdefault": "booking-form-module-scss-module__BeivHa__tabdefault",
  "tabdefault1": "booking-form-module-scss-module__BeivHa__tabdefault1",
  "tabs": "booking-form-module-scss-module__BeivHa__tabs",
});
